<div style="height: 100px"></div>
<div>
  <div class="content">
    <div class="container" fxLayout="column">
      <app-colecao #colecao></app-colecao>
    </div>
  </div>
</div>

